import axiosInstance from "./axiosInstance";
import PrescriptionsData from "../types/PrescriptionsData";
import {PrescriptionFilter} from "../types/PrescriptionFilter";
import CreatePrescriptionRequest from "../types/CreatePrescriptionRequest";
import CreateItemResponse from "../types/CreateItemResponse";
import UpdatePrescriptionRequest from "../types/UpdatePrescriptionRequest";
import {getParams} from "./util";
import {Prescription} from "../types/Prescription";
import FlagPrescriptionRequest from "../types/FlagPrescriptionRequest";

export const fetchPrescriptions = async (params: any) => {
    const queryParams = getParams(params);
    const url = `/prescriptions${queryParams}`;
    return axiosInstance.get<PrescriptionsData>(url)
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}

export const fetchPrescriptionById = async (id: number) => {
    const url = `/prescriptions/${id}`;
    return axiosInstance.get<Prescription>(url)
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))
}

export const fetchPrescriptionFilters = async () =>
    axiosInstance.get<PrescriptionFilter>("/prescriptions/filters")
        .then(response => response.data)
        .catch(error => console.error("ERROR", error))

export const postPrescription = async (request: CreatePrescriptionRequest): Promise<CreateItemResponse | void> => {
    return axiosInstance.post<CreateItemResponse>("/prescriptions", request)
        .then(response => response.data)
}

export const updatePrescription = async (id: number, request: UpdatePrescriptionRequest) => {
    return axiosInstance.patch<void>(`/prescriptions/${id}`, request)
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
}

export const flagPrescription = async (id: number, request: FlagPrescriptionRequest) => {
    return axiosInstance.patch<void>(`/prescriptions/${id}/flag`, request)
        .then(response => response.data)
        .catch(error => {
            throw error;
        });
}

export const downloadPrescriptionExcel = async (params: any): Promise<any | void> => {
    const queryParams = getParams(params);
    return axiosInstance.get<any>(`/prescriptions/excel${queryParams}`, {
        responseType: 'blob',
    })
        .then(response => response.data)
        .catch(error => error.response.data)
}